import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube as fabFaYoutube } from '@fortawesome/free-brands-svg-icons';

import AutoPlayVideo from 'Components/Utility/Video/AutoPlayVideo';
import FluidImg from 'Components/Utility/FluidImg';


const HpOmenVideoImgLoader = ({
  iconSize,
  cover,
  video,
  folder,
}) => {
  const [showVideo, setShowVideo] = useState(false);

  const loadVideo = () => {
    setShowVideo(true);
  };

  if (showVideo) {
    return (
      <div className="video-wrapper">
        <AutoPlayVideo width="100%" height="auto" src={video} className="youtube-video" />
      </div>
    );
  }

  return (
    <div className="hp-omen-oasis-video-img-container">
      <div className="cover-container">
        <FluidImg
          className="m-auto img-force-full"
          src={cover}
          alt={cover}
          folder={folder}
        />
      </div>


      <div className="video-icon-container">
        <Button aria-label="Play video" color="link" onClick={loadVideo}>
          <FontAwesomeIcon icon={fabFaYoutube} size={iconSize} title="YouTube" />
        </Button>
      </div>
    </div>
  );
};

HpOmenVideoImgLoader.propTypes = {
  iconSize: PropTypes.string,
  cover: PropTypes.string.isRequired,
  video: PropTypes.string.isRequired,
  folder: PropTypes.string,
};

HpOmenVideoImgLoader.defaultProps = {
  iconSize: '1x',
  folder: 'assets/partners/hpomenoasis',
};

export default HpOmenVideoImgLoader;
